import { every, groupBy, map } from 'lodash';
import { getTotalSelectedTickets } from '../../containers/ticketSelection/utils/ticketUtils';
import { OrderAttendee } from '../../models/attendee';
import { Ticket } from '../../models/tickets';
import { CheckoutState } from '../../state';
import { getAttendees } from '../order';
import { getSelectedTickets } from './getSelectedTickets';

/**
 * Get tickets with associated assigned unit data
 *
 * Underscore prefix used because this is not a true selector, rather it's used
 * as a helper for getTicketsProps
 *
 * @was `utils/forms.js: getTicketsWithAssignedUnit
 */
const _getTicketsWithAssignedUnit = (
    tickets: Array<Ticket>,
    attendees: OrderAttendee[] = [],
) => {
    const groupedAttendeesByTicketClass = groupBy(attendees, 'ticketClassId');

    return tickets.map((ticket) => {
        const attendeesData = groupedAttendeesByTicketClass[ticket.id];
        let assignedUnits;

        if (attendeesData) {
            assignedUnits = map(attendeesData, 'assignedUnit');
        }

        return attendeesData && every(assignedUnits)
            ? {
                  ...ticket,
                  assignedUnits,
              }
            : ticket;
    });
};

export const getTicketsProps = (state: CheckoutState) => {
    const selectedTickets = getSelectedTickets(state);
    const attendees = getAttendees(state);

    return {
        selectedTickets: _getTicketsWithAssignedUnit(
            selectedTickets,
            attendees,
        ),
        totalTicketQuantity: getTotalSelectedTickets(selectedTickets),
    };
};
